import React from 'react';
import {
  BLACK,
  BORDER,
  CARD_BG,
  GOLD_DARK,
  INK_BG,
  INK_TEXT,
  SURFACE_2,
  TEXT_MUTED,
} from '../../components/ProposalFlow/theme';
import type { ProductionOffering } from '../../types/pricingPlans';
import { Check, PRICING_CTA_URL } from './PlanComparisonTable';

interface Props {
  offering: ProductionOffering;
  // Heading colours follow the page background (see PricingPage).
  headingColor: string;
  mutedColor: string;
}

// The TDC Production block beneath the plan table. Deliberately NOT a
// plans-as-columns table: production is an add-on on any plan (Free
// included), priced per production and never part of the monthly fee, so
// per-plan checkmarks would read as "included in the tier". Copy comes
// from the API's PRODUCTION_OFFERING (lib/brandPlans.js). No dollar
// figures by design.
export function ProductionSection({ offering, headingColor, mutedColor }: Props) {
  return (
    <div style={{ marginTop: 56 }}>
      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <div
          style={{
            display: 'inline-block',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.8,
            textTransform: 'uppercase',
            color: GOLD_DARK,
            marginBottom: 8,
          }}
        >
          {offering.eyebrow}
        </div>
        <h2 style={{ fontSize: 24, fontWeight: 700, color: headingColor, margin: 0 }}>{offering.title}</h2>
        <p style={{ fontSize: 15, color: mutedColor, marginTop: 10, maxWidth: 760, marginLeft: 'auto', marginRight: 'auto' }}>
          {offering.intro}
        </p>
      </div>
      <div
        style={{
          border: `1px solid ${BORDER}`,
          borderRadius: 16,
          background: CARD_BG,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            background: SURFACE_2,
            padding: '8px 20px',
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.6,
            textTransform: 'uppercase',
            color: TEXT_MUTED,
            borderBottom: `1px solid ${BORDER}`,
          }}
        >
          Every production includes
        </div>
        <ul
          style={{
            listStyle: 'none',
            margin: 0,
            padding: '8px 20px',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            columnGap: 24,
          }}
        >
          {offering.includes.map((item) => (
            <li
              key={item}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 10,
                padding: '10px 0',
                fontSize: 14,
                color: BLACK,
                borderBottom: `1px solid ${BORDER}`,
              }}
            >
              <span style={{ flex: '0 0 18px', marginTop: 1 }}>
                <Check />
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            padding: '18px 20px 20px',
          }}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {offering.offerings.map((name) => (
              <span
                key={name}
                style={{
                  display: 'inline-block',
                  border: `1px solid ${BORDER}`,
                  borderRadius: 999,
                  padding: '6px 12px',
                  fontSize: 13,
                  fontWeight: 600,
                  color: BLACK,
                }}
              >
                {name}
              </span>
            ))}
          </div>
          <a
            href={PRICING_CTA_URL}
            target="_top"
            rel="noreferrer"
            style={{
              display: 'inline-block',
              background: INK_BG,
              color: INK_TEXT,
              borderRadius: 10,
              padding: '10px 18px',
              fontSize: 13.5,
              fontWeight: 600,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}
          >
            {offering.cta}
          </a>
        </div>
      </div>
      <p style={{ fontSize: 12, color: mutedColor, textAlign: 'center', marginTop: 18 }}>{offering.footnote}</p>
    </div>
  );
}
